import { render, staticRenderFns } from "./TaskTodealNew.vue?vue&type=template&id=73e83416&"
import script from "./TaskTodealNew.vue?vue&type=script&lang=ts&"
export * from "./TaskTodealNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports